import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

interface UserLogoutState {
	logoutResponse: any;
	status: boolean;
	error: string | null;
}

const initialState: UserLogoutState = {
	logoutResponse: {},
	status: false,
	error: null
};

const userLogoutApi = createAsyncThunk<any, void>('userLogoutApi/userLogoutApi', async (_, thunkAPI) => {
	try {
		const response = await API.post(API_ENDPOINTS.USER_LOGOUT);
		return response;
	} catch (error: any) {
		return thunkAPI.rejectWithValue(error.response.data);
	}
});

const userLogoutApiSlice = createSlice({
	name: 'userLogoutApi',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(userLogoutApi.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(userLogoutApi.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.logoutResponse = action.payload;
			})
			.addCase(userLogoutApi.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to logout user';
			});
	}
});

export { userLogoutApi };
export const { reset: resetUserLogoutApi } = userLogoutApiSlice.actions;
export const userLogoutApiReducer = userLogoutApiSlice.reducer;
